import { render, staticRenderFns } from "./FeatureIcons.vue?vue&type=template&id=5c2b9456&scoped=true"
import script from "./FeatureIcons.vue?vue&type=script&lang=js"
export * from "./FeatureIcons.vue?vue&type=script&lang=js"
import style0 from "./FeatureIcons.vue?vue&type=style&index=0&id=5c2b9456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b9456",
  null
  
)

export default component.exports